import API from "../../utils/axios";
import {
  SET_ACCOUNT_DRAWER_OPEN,
  SET_PROJECTS,
  SET_APP_PROJECTS,
  SET_APP_STOPS,
  SET_PROJECTS_QUANTITY,
  SET_WEBHOOKS,
  SET_WEBHOOK_EVENT_TYPES,
  SET_ACTIVE_DIALOG,
  SET_BILLING_OPEN,
  SET_CURRENT_PRICING_DIALOG,
  SET_PAYMENT,
  SET_INVOICES,
  SET_API_KEYS,
  SET_BILLING_DETAILS,
  SET_UPLOAD_STOPS_OPEN,
  SET_UPLOAD_STOPS_SIMPLE_OPEN,
  SET_TAGS,
  SET_TAGS_LIST_LOADED,
  SET_TEMPLATES,
  SET_TEMPLATES_LIST_LOADED,
  SET_APPS
} from "./types";

export const setActiveDialog = dialogName => dispatch => {
  dispatch({
    type: SET_ACTIVE_DIALOG,
    dialogName
  });
};

export const setPricingOpen = bool => dispatch => {
  dispatch({
    type: SET_BILLING_OPEN,
    bool
  });
};

export const setUploadStopsOpen = bool => dispatch => {
  dispatch({
    type: SET_UPLOAD_STOPS_OPEN,
    bool
  });
};

export const setUploadStopsSimpleOpen = bool => dispatch => {
  dispatch({
    type: SET_UPLOAD_STOPS_SIMPLE_OPEN,
    bool
  });
};

export const setDrawerOpenGlobal = open => {
  return {
    type: SET_ACCOUNT_DRAWER_OPEN,
    open
  };
};

export const setProjects = projects => dispatch => {
  dispatch({
    type: SET_PROJECTS,
    projects
  });
};

export const setApps = apps => dispatch => {
  dispatch({
    type: SET_APPS,
    apps
  });
};

export const setAppProjects = appProjects => dispatch => {
  dispatch({
    type: SET_APP_PROJECTS,
    appProjects
  });
};

export const setAppStops = appStops => dispatch => {
  dispatch({
    type: SET_APP_STOPS,
    appStops
  });
};

export const setProjectsQuantity = quantity => dispatch => {
  dispatch({
    type: SET_PROJECTS_QUANTITY,
    quantity
  });
};

export const setWebhooks = webhooks => dispatch => {
  dispatch({
    type: SET_WEBHOOKS,
    webhooks
  });
};

export const setApiKeys = apiKeys => dispatch => {
  dispatch({
    type: SET_API_KEYS,
    apiKeys
  });
};

export const setInvoices = invoices => dispatch => {
  dispatch({
    type: SET_INVOICES,
    invoices
  });
};

export function setTags(tags) {
  return function (dispatch) {
    dispatch({
      type: SET_TAGS,
      tags
    });
    dispatch({ type: SET_TAGS_LIST_LOADED });
  };
}

export function setTemplates(templates) {
  return function (dispatch) {
    dispatch({
      type: SET_TEMPLATES,
      templates
    });
    dispatch({ type: SET_TEMPLATES_LIST_LOADED });
  };
}

export function toggleTemplate(template) {
  return function (dispatch, getState) {
    const templates = getState().account.templates;
    dispatch({
      type: SET_TEMPLATES,
      templates: templates.map(el => {
        return el.id === template.id ? { ...el, is_enable: !el.is_enable } : el;
      })
    });
  };
}

export const setEventTypes = eventTypes => dispatch => {
  dispatch({
    type: SET_WEBHOOK_EVENT_TYPES,
    eventTypes
  });
};

export const setPayment = obj => dispatch => {
  dispatch({
    type: SET_PAYMENT,
    obj
  });
};

export const setBillingDetails = obj => dispatch => {
  dispatch({
    type: SET_BILLING_DETAILS,
    obj
  });
};

export const setCurrentPricingDialog = dialogName => dispatch => {
  dispatch({
    type: SET_CURRENT_PRICING_DIALOG,
    dialogName
  });
};

export const getAppProjects = () => dispatch => {
  API.get(`/v1/projects`)
    .then(res => dispatch(setAppProjects(res.data.projects)))
    .catch(err => {
      console.log(err);
    });
};
